import PracticeSupportAPI from '@/apis/business/student/practice-support-api.js'
import Enumeration from '@/common/enumeration.js'

export default {
  namespaced: true,
  state: {
    courseFeesback: [],
    partnerID: Enumeration.ParentIDEnum.HOCMAI
  },

  getters: {

  },

  mutations: {
    setPartnerID (state, partnerID) {
      state.partnerID = partnerID
    }
  },

  actions: {
    /**
     * Thêm dữ liệu để hỗ trợ
     * @param {*} context
     * @param {*} courseFeesback
     * @returns
     */
    insertCourseFeedback (context, courseFeesback) {
      return new Promise((resolve, reject) => {
        PracticeSupportAPI.postAsync('supportParam', courseFeesback)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }

}
